export default {
  customerApi: {
    manageCustomers: 'CustomerApi/ManageCustomers',
    organizationAvailableSubscriptions:
      'CustomerApi/OrganizationAvailableSubscriptions',
    customerAvailableSubscriptions: 'CustomerApi/CustomerAvailableSubscriptions',
    organizationStatistics: 'CustomerApi/OrganizationStatistics',
    assignSubscriptionCustomerRole: 'CustomerApi/AssignSubscriptionCustomerRole',
    addCustomersToSubscriptions: 'CustomerApi/AddCustomersToSubscriptions',
    removeCustomersFromSubscriptions: 'CustomerApi/RemoveCustomersFromSubscriptions',
    removeCustomersFromOrganization: 'CustomerApi/RemoveCustomersFromOrganization',
    availableSubscriptionRoles: 'CustomerApi/AvailableSubscriptionRoles',
    productListDownload: 'CustomerApi/ProductListDownload',
  },
  statistics: {
    viewerStatisticsReport: '/sdcustomer/viewerstatistics',
  },
  registration: {
    countries: 'api/customerregistration/countries',
    companySearch: 'api/customerregistration/companies',
    schools: 'api/customerregistration/schools',
    validateSchoolEmail: 'api/customerregistration/schools/validate',
    createCompanyWithOrgUser: 'api/customerregistration/companywithorg',
    createCompanyWithoutOrgUser: 'api/customerregistration/companywithoutorg',
    createPrivateUser: 'api/customerregistration/private',
    createStudentUser: 'api/customerregistration/student',
    topic: 'api/customerregistration/topic',
    account: 'api/customerregistration/account',
    activationlink: 'api/customerregistration/activationlink',
  },
  global: {
    header: 'api/header',
    footer: 'api/footer',
    search: 'api/search',
  },
};
